import React from 'react';
import { observer } from 'mobx-react';

import { LocationIcon, PhoneIcon, EmailIcon } from 'app/commonComponents/icons';
import { colors } from 'app/variables';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import { Container, IconContainer, Link } from './styles/_addressInfo';

const AddressInfo = observer(() => {
  const { facility, prefersPhone, prefersEmail } = view;

  return (
    <Container>
      {facility.street && facility.zip_code && facility.city && (
        <IconContainer>
          <LocationIcon
            aria-hidden="true"
            style={{
              stroke: colors.pacificBlue,
              width: '2rem',
              height: '2rem',
            }}
            viewBox="0 0 37 37"
          />
          <Link
            href={`https://www.google.com/maps/search/?api=1&query=${
              (facility.location && facility.location[1]) || 49.4221588
            },${(facility.location && facility.location[0]) || 11.0815372}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {facility.street}, {facility.zip_code} {facility.city}
          </Link>
        </IconContainer>
      )}
      {prefersPhone && facility.phone ? (
        <IconContainer>
          <PhoneIcon
            aria-hidden="true"
            xsmall
            style={{ color: colors.pacificBlue }}
          />
          <Link href={`tel:${facility.phone}`}>{facility.phone}</Link>
        </IconContainer>
      ) : null}
      {prefersEmail && facility.email ? (
        <IconContainer>
          <EmailIcon
            aria-hidden="true"
            xsmall
            style={{ color: colors.pacificBlue }}
          />
          <Link href={`mailto:${facility.phone}`}>{facility.email}</Link>
        </IconContainer>
      ) : null}
    </Container>
  );
});

export default AddressInfo;
